<template>
  <main id="main" class="loyaltylandingpage">
    <div class="container-new">
      <div class="row-new">
        <h1 class="col-12 col-md-6">
          {{ insertString("Global", "Account", "CreateAccount") }}
        </h1>
        <div class="col-12 col-md-6">
          <div
            class="loyaltylandingpage-loyaltytext"
            v-html="model.LoyaltyText"
          ></div>
          <div
            class="alert alert-default col-12 col-md-10"
            v-if="model.ReferralCode"
            v-html="model.ReferralLink"
          ></div>
          <EmailBlock
            class="text-center text-md-left mt-4"
            :email="model.Email"
            :urlSegment="model.PageUrl"
            @on-input="changeEmail"
            @startRegistration="joinNow()"
          ></EmailBlock>
        </div>
      </div>

      <div class="row-new mt-5">
        <h2 class="col-12 mt-4 mb-5">
          {{ insertString("LoyaltyRegistration", "WhatYouGet") }}
        </h2>
      </div>
    </div>

    <div class="container-new mobile-no-padding">
      <div class="row-new">
        <div
          v-for="(teaser, index) in model.ContentArea"
          :key="index"
          class="teaser.ContentAreaCssClass col-12 col-md-4"
        >
          <TeaserItem :model="teaser"></TeaserItem>
        </div>
      </div>
    </div>

    <div class="container-fluid-new loyaltylandingpage-signup">
      <div class="row-new">
        <div class="col-12">
          <div class="container-new">
            <div class="row-new mt-5">
              <h2 class="col-12 mb-4">
                {{ insertString("LoyaltyRegistration", "SignUpLoyalty") }}
              </h2>
              <EmailBlock
                class="col-12 col-md-6 text-center text-md-left"
                :email="model.Email"
                :urlSegment="model.PageUrl"
                @on-input="changeEmail"
                @startRegistration="joinNow()"
              ></EmailBlock>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TeaserItem from '@/Scripts/components/shared/TeaserItem.vue';
import EmailBlock from '@/Scripts/components/pages/loyalty/landingpage/EmailBlock.vue';
import themeHelper from '@/Scripts/lib/helper/themeHelper.js';
import { TrackerLoyaltyRegistrationStarted } from '@/Scripts/lib/helper/trackingHelper.js';
import Api from '@/Scripts/api/api';
import UrlHelper from '@/Scripts/lib/helper/urlHelper.js';

export default {
  extends: themeHelper,
  components: {
    TeaserItem,
    EmailBlock
  },
  data () {
    return {
      model: {},
      themeName: 'black'
    };
  },
  computed: {

  },
  created () {
    this.getLoyaltyLandingPage();
  },
  methods: {
    getLoyaltyLandingPage () {
      Api.getContentByFriendlyUrl(UrlHelper.getCurrentUrlWithAction('json')).then(response => {
        this.model = response.data;
      });
    },
    changeEmail: function (value) {
      this.model.Email = value;
    },
    joinNow () {
      if (this.model.Email.length === 0) {
        return false;
      }

      TrackerLoyaltyRegistrationStarted(this.model.Email);

      const url = `/${this.model.PageUrl}/Submit`;
      Api.post(url, { email: this.model.Email, referralCode: this.model.ReferralCode, redirectUrl: this.model.RedirectUrl }, '')
        .then(response => {
          window.location.href = window.location.origin + response.data.RedirectUrl;
        });
    }
  },
  mounted () {
    this.$nextTick(function () {
      document.querySelector('body').classList.remove('loading-site');
    });
  }

};
</script>

<style lang="scss" src="@/scss/objects/objects.grid-loyalty.scss"></style>
<style lang="scss" src="@/scss/objects/objects.grid-loyaltylandingpage.scss"></style>
